import { render, staticRenderFns } from "./AiCallingSimplePromptPicker.vue?vue&type=template&id=f6737034&scoped=true&"
import script from "./AiCallingSimplePromptPicker.vue?vue&type=script&lang=js&"
export * from "./AiCallingSimplePromptPicker.vue?vue&type=script&lang=js&"
import style0 from "./AiCallingSimplePromptPicker.vue?vue&type=style&index=0&id=f6737034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6737034",
  null
  
)

export default component.exports